import { jsonFetch } from "@/lib/helpers";
import { Monitor } from "@/models";
import { GET_MONITORING_BETWEEN_RANGE_BY_ROOM_ID } from "./api-url.constants";
import { GetMonitoringBetweenRangeByMonitorIdResponseApiDto } from "./dtos";
import { mapperMonitorsDTOToMonitors } from "./mappers";

interface GetMonitoringBetweenRangeByRoomIdParams {
  roomId: string;
  from: number;
  to: number;
  monitorId?: string;
}

export const getMonitoringBetweenRangeByRoomId = async ({
  roomId,
  from,
  to,
  monitorId,
}: GetMonitoringBetweenRangeByRoomIdParams): Promise<Monitor[]> => {
  let url = `${GET_MONITORING_BETWEEN_RANGE_BY_ROOM_ID}/${encodeURIComponent(roomId)}?from=${from}&to=${to}`;
  if (monitorId) url += `&monitorId=${encodeURIComponent(monitorId)}`;
  const monitorsDTO = await jsonFetch<GetMonitoringBetweenRangeByMonitorIdResponseApiDto>(url);
  return mapperMonitorsDTOToMonitors(monitorsDTO);
};
